// obesity level from BMI, on both the Asian and the WHO scale
//==============================

const UNDERWEIGHT = { label: 'Underweight', color: 'blue' }
const NORMAL = { label: 'Normal', color: 'green' }
const OVERWEIGHT = { label: 'Overweight', color: 'orange' }
const OBESE_1 = { label: 'Obese Class I', color: 'volcano' }
const OBESE_2 = { label: 'Obese Class II', color: 'red' }
const OBESE_3 = { label: 'Obese Class III', color: 'magenta' }

// each level applies below its "below" BMI value; the last one has no upper limit
// Asian cut-offs (commonly used in India): overweight from 23, obese from 25
const ASIAN_SCALE = [
    { below: 18.5, ...UNDERWEIGHT },
    { below: 23, ...NORMAL },
    { below: 25, ...OVERWEIGHT },
    { below: 30, ...OBESE_1 },
    { below: Infinity, ...OBESE_2 },
]

// WHO cut-offs: overweight from 25, obese from 30
const WHO_SCALE = [
    { below: 18.5, ...UNDERWEIGHT },
    { below: 25, ...NORMAL },
    { below: 30, ...OVERWEIGHT },
    { below: 35, ...OBESE_1 },
    { below: 40, ...OBESE_2 },
    { below: Infinity, ...OBESE_3 },
]

const levelOnScale = (bmi, scale) => {
    const { label, color } = scale.find((level) => bmi < level.below)
    return { label, color }
}

// reference table of both scales side by side, built from the scales above so it can't drift
// rows: { key, range, min, max, asian, who } where a BMI belongs to a row when min <= bmi < max
export const bmiScaleTable = () => {
    const cutOffs = [...new Set([...ASIAN_SCALE, ...WHO_SCALE].map((level) => level.below))]
        .filter((value) => value !== Infinity)
        .sort((a, b) => a - b)

    const bounds = [0, ...cutOffs, Infinity]

    return bounds.slice(0, -1).map((min, index) => {
        const max = bounds[index + 1]
        let range = `${min} – ${(max - 0.1).toFixed(1)}`
        if (min === 0) range = `Under ${max}`
        if (max === Infinity) range = `${min} and above`

        return {
            key: range,
            range,
            min,
            max,
            asian: levelOnScale(min, ASIAN_SCALE),
            who: levelOnScale(min, WHO_SCALE),
        }
    })
}

// { asian, who } levels for a BMI, or null when there is no valid BMI
export const bmiLevels = (bmiValue) => {
    const bmi = parseFloat(bmiValue)
    if (!(bmi > 0)) return null

    return {
        asian: levelOnScale(bmi, ASIAN_SCALE),
        who: levelOnScale(bmi, WHO_SCALE),
    }
}
